// extracted by mini-css-extract-plugin
module.exports = {"rating":"StarRating_rating_7YFtA","text":"StarRating_text_RwxyJ"};